import { useState } from "react";
import { useDispatch } from "react-redux";

import { postNasjon } from "../../../actions/nasjonerActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../utils/validationUtils";
import ModalGeneric from "../../Common/ModalGeneric";
import NasjonerForm from "../NasjonerForm";
import OpenModalComponent from "./OpenModalComponent";

const rules = {
  kode: "required;minLength=1;maxLength=50",
  navn: "required;minLength=3;maxLength=50",
};

const initState = () => ({
  open: false,
  submitButtonText: "Legg til ny",
  kode: "",
  navn: "",
  validationError: {},
});

export default function NasjonerModal() {
  const dispatch = useDispatch();
  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  const closeModal = () => setState(initState());

  const isFormValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePost = () => {
    update({ submitButtonText: "Legger til..." });
    dispatch(postNasjon({ kode: state.kode, navn: state.navn }))
      .then(closeModal)
      .catch(() => update({ submitButtonText: "Legg til ny" }));
  };

  const saveAndClose = () => {
    if (isFormValid()) handlePost();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const draft = { ...state, [name]: value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <ModalGeneric
      modalTitle="Legg til ny nasjon"
      open={state.open}
      closeModal={closeModal}
      openModal={() => update({ open: true })}
      OpenModalComponent={OpenModalComponent}
      submit={saveAndClose}
      submitButtonText={state.submitButtonText}
    >
      <NasjonerForm
        kode={state.kode}
        navn={state.navn}
        validationError={state.validationError}
        handleChange={handleChange}
      />
    </ModalGeneric>
  );
}
